import React from 'react'
import ScrollWrap from '../components/ScrollWrap'
import Navbar from '../components/Navbar'
import MainWrap from '../components/MainWrap'
import ContactFormWrap from '../components/ContactFormWrap'
import Overlay from '../components/Overlay'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickSliderData2 } from '../data/SlickSliderData'
import FundamentalCourses2 from '../components/FundamentalCourses2'
import { FundamentalCoursesPageData } from '../data/FundamentalCoursesData'
import CounterArea from '../components/CounterArea'
import { CounterData2 } from '../data/CounterData'
import Enroll from '../components/Enroll'
import { EnrollData4 } from '../data/EnrollData'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import ContactAnchor from '../components/ContactAnchor'
import LoginAnchor from '../components/LoginAnchor'

export default function FundamentalModules() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor />
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickSliderData2} />
            <FundamentalCourses2  data={FundamentalCoursesPageData} />
            <CounterArea data={CounterData2} />
            <Enroll data={EnrollData4} />
            <RelatedCourses />
            <Footer />
        </>
    )
}
